// extracted by mini-css-extract-plugin
export var center = "style-module--center--1479a";
export var container = "style-module--container--e0b7b";
export var full = "style-module--full--5cda5";
export var left = "style-module--left--d77e7";
export var right = "style-module--right--0e629";
export var wide = "style-module--wide--f8ee8";